import React from 'react';
import { Container, Row, Col, Nav, Navbar } from 'react-bootstrap';
import { TfiInfoAlt } from 'react-icons/tfi';
import { useTranslation } from 'react-i18next';
import localizedPath from '../../utils/localization';
import { SmoothScrollLink } from '../../utils/navUtils';

function ContactBanner() {
    const { t } = useTranslation();

    return (
        <section className="contact-banner">
            <Container>
                <Row>
                    <Col lg={10}>
                        <h3 className="banner-title">
                            <TfiInfoAlt size={30} />
                            {t('banners.contact-banner-text')}
                        </h3>
                    </Col>
                    <Col lg={2}>
                        <Nav className="contact-nav-button">
                            <SmoothScrollLink to={localizedPath('/contact#page-top')}>
                                <Navbar.Brand>{t('buttons.contact-us')}</Navbar.Brand>
                            </SmoothScrollLink>
                        </Nav>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default ContactBanner;
